const THEME_STORAGE_KEY = 'app_theme_vars_v1'

export function loadThemeFromStorage (): Record<string, string> | null {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed === 'object') return parsed
    return null
  }
  catch {
    return null
  }
}

export function saveThemeToStorage (vars: Record<string, string>): void {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(vars))
  }
  catch {
    // ignore
  }
}
